module.exports = __webpack_public_path__ + "img/chofu_buy_off.ef72e876.svg";